import React from "react";
import { Link } from "react-router-dom";
import Frame from "../bench/Frame";
import Meta from "../bench/Meta";

const NotFound = () => (
  <Frame>
    <Meta title="404" description="That route isn't on the bench." />
    <section className="workbench studio-404">
      <div className="studio-404__num">404</div>
      <h1 className="studio-404__title">That route isn't on the bench.</h1>
      <p className="studio-404__lede">
        The page may have been retired, or the link may be miswritten. Return to the studio or send a
        brief directly.
      </p>
      <div style={{ display: "flex", justifyContent: "center", gap: 14 }}>
        <Link to="/" className="btn-solid">Back to studio</Link>
        <Link to="/#contact" className="btn-outline">Start a brief</Link>
      </div>
    </section>
  </Frame>
);

export default NotFound;
